import axios from "../utils/axios";

export const getBreakdownEffects = () => {
    return axios.get(`/BreakdownEffect/GetList`);
};

export const addBreakdownEffect = (payload) => {
    return axios.post(`/BreakdownEffect/Add`, payload);
};

export const updateBreakdownEffect = (payload) => {
    return axios.post(`/BreakdownEffect/Update`, payload);
};

export const deleteBreakdownEffect = (payload) => {
    return axios.post(`/BreakdownEffect/Delete`, payload);
};
